export default "__VITE_ASSET__YnHRjHyx__"